import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-6 text-navy-light text-lg leading-relaxed" data-id="element-37">
    <h2 className="text-3xl font-bold text-navy font-playfair" data-id="element-38">
      Política de Privacidad
    </h2>
    <p data-id="element-39">
      <strong data-id="element-40">Última actualización:</strong> Mayo 2026
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-41">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-42">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      entregar el producto digital, incluyendo tu nombre y dirección de correo
      electrónico.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-43">2. Uso de la Información</h3>
    <p data-id="element-44">Tu información personal se utiliza exclusivamente para:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-45">
      <li data-id="element-46">Procesar y entregar tu compra digital.</li>
      <li data-id="element-47">Enviarte el enlace de descarga del producto.</li>
      <li data-id="element-48">Comunicarnos contigo en caso de problemas con tu pedido.</li>
    </ul>

    <h3 className="text-xl font-bold text-navy" data-id="element-49">3. Protección de Datos</h3>
    <p data-id="element-50">
      No vendemos, compartimos ni alquilamos tu información personal a terceros.
      Utilizamos medidas de seguridad estándar de la industria para proteger tus
      datos.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-51">4. Cookies</h3>
    <p data-id="element-52">
      Este sitio puede utilizar cookies para mejorar tu experiencia de
      navegación y para fines analíticos. Puedes desactivar las cookies en la
      configuración de tu navegador.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-53">5. Tus Derechos</h3>
    <p data-id="element-54">
      Tienes derecho a solicitar la eliminación de tus datos personales en
      cualquier momento.
    </p>
  </div>;
const termsContent = <div className="space-y-6 text-navy-light text-lg leading-relaxed" data-id="element-55">
    <h2 className="text-3xl font-bold text-navy font-playfair" data-id="element-56">
      Términos y Condiciones
    </h2>
    <p data-id="element-57">
      <strong data-id="element-58">Última actualización:</strong> Mayo 2026
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-59">1. Producto Digital</h3>
    <p data-id="element-60">
      "Legado Digital Seguro" es un producto digital en formato PDF descargable.
      Al completar tu compra, recibirás acceso inmediato al contenido a través
      de un enlace de descarga.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-61">2. Uso Personal</h3>
    <p data-id="element-62">
      El contenido adquirido es para uso personal y familiar únicamente. Queda
      prohibida la reproducción, distribución o reventa del material sin
      autorización expresa.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-63">3. Entrega</h3>
    <p data-id="element-64">
      El producto se entrega de forma digital e inmediata tras la confirmación
      del pago. No se realizan envíos físicos.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-65">4. Política de Reembolso</h3>
    <p data-id="element-66">
      Debido a la naturaleza digital del producto, no se ofrecen reembolsos una
      vez que el archivo ha sido descargado. Si tienes problemas técnicos con la
      descarga, estaremos encantados de ayudarte.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-67">
      5. Limitación de Responsabilidad
    </h3>
    <p data-id="element-68">
      Este producto es una guía informativa y organizativa. No constituye
      asesoramiento legal, financiero ni tecnológico profesional. El usuario es
      responsable de la custodia y seguridad de la información que registre en
      las plantillas.
    </p>

    <h3 className="text-xl font-bold text-navy" data-id="element-69">6. Modificaciones</h3>
    <p data-id="element-70">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones serán efectivas desde su publicación en este
      sitio.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-cream-dark py-10 text-center px-6" data-id="element-71">
        <div className="max-w-4xl mx-auto" data-id="element-72">
          <p className="text-lg mb-4 font-playfair font-bold text-gold" data-id="element-73">
            Legado Digital Seguro
          </p>
          <p className="text-sm opacity-80" data-id="element-74">
            © {new Date().getFullYear()} Legado Digital Seguro. Todos los
            derechos reservados.
          </p>

          <div className="flex items-center justify-center gap-6 mt-4" data-id="element-75">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-cream-dark/80 hover:text-gold transition-colors underline underline-offset-2" data-id="element-76">
              Política de Privacidad
            </button>
            <span className="text-cream-dark/40" data-id="element-77">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-cream-dark/80 hover:text-gold transition-colors underline underline-offset-2" data-id="element-78">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm opacity-60 mt-6 max-w-2xl mx-auto" data-id="element-79">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-80">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-navy-dark/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-81">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto p-8 md:p-10 relative" onClick={e => e.stopPropagation()} data-id="element-82">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-10 h-10 bg-cream rounded-full flex items-center justify-center hover:bg-cream-dark transition-colors" aria-label="Cerrar" data-id="element-83">
                <XIcon className="w-5 h-5 text-navy" data-id="element-84" />
              </button>

              {activeModal === 'privacy' ? privacyContent : termsContent}

              <div className="mt-8 pt-6 border-t border-cream-dark" data-id="element-85">
                <button onClick={() => setActiveModal(null)} className="bg-navy text-cream px-8 py-3 rounded-xl font-semibold hover:bg-navy-light transition-colors text-lg" data-id="element-86">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}